// Complete Contract Template - IDENTICAL to PDF (11 pages)
export const generateContractHTML = (data) => {
  const d = data;
  
  return `<!DOCTYPE html>
<html>
<head>
  <meta charset="UTF-8">
  <title>Contract de Închiriere - ${d.tenantName}</title>
  <style>
    @page { 
      size: A4; 
      margin: 2cm 1.5cm; 
    }
    * { 
      margin: 0; 
      padding: 0; 
      box-sizing: border-box; 
    }
    body { 
      font-family: 'Times New Roman', Times, serif; 
      font-size: 11pt; 
      line-height: 1.5; 
      color: #000; 
      background: #fff;
      padding: 15px 30px;
    }
    .header {
      text-align: center;
      margin-bottom: 20px;
    }
    .header h1 {
      font-size: 14pt;
      font-weight: bold;
      text-transform: uppercase;
      margin-bottom: 5px;
    }
    .header .subtitle {
      font-size: 10pt;
      font-style: italic;
    }
    .article-title {
      font-weight: bold;
      font-size: 11pt;
      margin: 18px 0 10px 0;
      text-transform: uppercase;
    }
    .bilingual-table {
      width: 100%;
      border-collapse: collapse;
      margin: 10px 0;
      font-size: 10pt;
    }
    .bilingual-table td {
      width: 50%;
      vertical-align: top;
      padding: 8px 10px;
      border: 1px solid #999;
    }
    .bilingual-table .col-ro {
      background-color: #f8f8f8;
    }
    .bilingual-table .col-en {
      background-color: #fff;
    }
    .bilingual-table .header-row td {
      font-weight: bold;
      background-color: #e0e0e0;
      text-align: center;
      padding: 5px;
    }
    .parties-box {
      border: 1px solid #000;
      padding: 12px;
      margin: 12px 0;
      background: #fafafa;
    }
    .parties-box h3 {
      font-weight: bold;
      text-transform: uppercase;
      margin-bottom: 8px;
      font-size: 11pt;
    }
    .field-row {
      margin: 5px 0;
      font-size: 10pt;
    }
    .field-label {
      font-weight: bold;
    }
    .field-value {
      border-bottom: 1px dotted #000;
      display: inline-block;
      min-width: 120px;
      padding: 0 5px;
    }
    .intro-note {
      background: #fffde7;
      border: 1px solid #e0c000;
      padding: 12px;
      margin: 15px 0;
      font-size: 10pt;
    }
    ul {
      margin-left: 18px;
      margin-top: 6px;
    }
    li {
      margin: 4px 0;
    }
    .signature-section {
      margin-top: 40px;
      page-break-inside: avoid;
    }
    .signature-row {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }
    .signature-block {
      width: 45%;
      text-align: center;
    }
    .signature-block h4 {
      font-weight: bold;
      text-transform: uppercase;
      margin-bottom: 10px;
      font-size: 11pt;
    }
    .signature-line {
      border-bottom: 1px solid #000;
      height: 30px;
      margin: 8px 0;
    }
    .legal-section {
      margin-top: 30px;
      padding: 15px;
      background: #f9f9f9;
      border: 1px solid #ccc;
      font-size: 9pt;
      line-height: 1.4;
      page-break-inside: avoid;
    }
    .legal-section h4 {
      font-weight: bold;
      margin-bottom: 10px;
      font-size: 10pt;
    }
    .page-footer {
      text-align: center;
      font-size: 9pt;
      color: #666;
      margin-top: 20px;
    }
    .page-number {
      text-align: right;
      font-size: 9pt;
      color: #888;
      margin-top: 15px;
    }
    @media print {
      body { padding: 0; }
    }
  </style>
</head>
<body>

<div class="header">
  <h1>CONTRACT DE ÎNCHIRIERE / RENTING AGREEMENT</h1>
  <p>din/from <strong>${d.contractDate}</strong></p>
  <p class="subtitle">Privind cedarea dreptului de folosință a imobilului cu destinație locuință, situat în Mun. Iași</p>
  <p class="subtitle">Regarding the assignment of the right to use the residential property located in Iași</p>
</div>

<div class="article-title">ART. 1 PĂRȚILE: PROPRIETARII / OWNERS</div>

<div class="parties-box">
  <p><strong>${d.ownerName}</strong>, domiciliată în ${d.ownerAddress}, identificată cu C.I. seria <strong>${d.ownerIdSeries}</strong> nr. <strong>${d.ownerIdNumber}</strong>, emis de ${d.ownerIdIssuedBy}</p>
</div>

<div class="parties-box">
  <h3>CHIRIAȘII / TENANTS</h3>
  <div class="field-row">
    <span class="field-label">Full Name:</span> <span class="field-value">${d.tenantName}</span>
    &nbsp;&nbsp;
    <span class="field-label">Country of residence:</span> <span class="field-value">${d.tenantCountry}</span>
  </div>
  <div class="field-row">
    <span class="field-label">Address:</span> <span class="field-value" style="min-width:300px">${d.tenantAddress}</span>
  </div>
  <div class="field-row">
    <span class="field-label">Passport number/ID document:</span> <span class="field-value">${d.tenantPassport}</span>
    &nbsp;&nbsp;
    <span class="field-label">valid until:</span> <span class="field-value">${d.tenantPassportValid}</span>
  </div>
  <div class="field-row">
    <span class="field-label">Phone number:</span> <span class="field-value">${d.tenantPhone}</span>
    &nbsp;&nbsp;
    <span class="field-label">WhatsApp number:</span> <span class="field-value">${d.tenantWhatsapp}</span>
  </div>
  <div class="field-row">
    <span class="field-label">Email:</span> <span class="field-value" style="min-width:200px">${d.tenantEmail}</span>
  </div>
</div>

<div class="intro-note">
  <strong>Notă introductivă / Introductory Note:</strong><br>
  Acest contract este redactat în format bilingv (română-engleză), cu scopul de a asigura claritate, transparență și aplicabilitate internațională.<br>
  <em>This agreement is drafted in bilingual format (Romanian-English) to ensure clarity, transparency, and international enforceability.</em>
</div>

<table class="bilingual-table">
  <tr class="header-row">
    <td class="col-ro">Română</td>
    <td class="col-en">English</td>
  </tr>
</table>

<!-- ART. 2 -->
<div class="article-title">ART. 2 OBIECTUL CONTRACTULUI / OBJECT OF AGREEMENT</div>
<table class="bilingual-table">
  <tr>
    <td class="col-ro">Obiectul contractului îl reprezintă cedarea dreptului de folosință a imobilului cu destinație locuință situat în <strong>${d.apartmentAddress}</strong>, Iași.</td>
    <td class="col-en">The object of the agreement is the assignment of the right to use the apartment as dwelling place located on <strong>${d.apartmentAddress}</strong>, Iași.</td>
  </tr>
</table>

<!-- ART. 3 -->
<div class="article-title">ART. 3 DURATA CONTRACTULUI / PERIOD OF AGREEMENT</div>
<table class="bilingual-table">
  <tr>
    <td class="col-ro">Prezentul contract de închiriere se încheie pe o perioadă de <strong>${d.durationMonths} luni</strong>, începând cu data de <strong>${d.startDate}</strong> până la data de <strong>${d.endDate}</strong>, inclusiv, și se prelungește automat dacă există acordul ambelor părți.</td>
    <td class="col-en">This renting agreement is entered over a period of <strong>${d.durationMonths} months</strong>, from <strong>${d.startDate}</strong> until <strong>${d.endDate}</strong>, included, and is extended automatically with parties' agreement.</td>
  </tr>
</table>

<!-- ART. 4 -->
<div class="article-title">ART. 4 CHIRIA / RENT</div>
<table class="bilingual-table">
  <tr>
    <td class="col-ro">
      Chiria lunară este în sumă de <strong>${d.rentEur} EUR/lună</strong>, fiind fixă pe toată perioada derulării contractului în contul:<br>
      <strong>${d.ownerIban}</strong>, BIC/SWIFT: <strong>${d.ownerSwift}</strong><br>
      BANCA: <strong>${d.ownerBank}</strong><br><br>
      
      La data semnării contractului, chiriașul achită suma de <strong>${d.depositEur} Euro</strong>, care reprezintă garanție apartament. <em>Garanția nu poate fi utilizată ca lună de chirie.</em><br><br>
      
      Până la data de <strong>${d.firstPaymentDate}</strong>, chiriașul va achita suma de <strong>${d.firstPaymentAmount} EUR</strong> reprezentând chiria pentru prima perioadă.<br><br>
      
      Următoarele plăți se vor face până la data de <strong>${d.monthlyPaymentDay}</strong> a fiecărei luni. Chiriașul nu este scutit de plata chiriei pe timpul verii/vacanței.<br><br>
      
      Chiriașii vor primi cheile și dreptul de a intra în apartament începând cu data de <strong>${d.keysDate}</strong>.<br><br>
      
      <strong>Penalități pentru întârziere:</strong><br>
      Pentru fiecare zi de întârziere la plata chiriei sau a utilităților, chiriașul datorează penalități de 0,1% din suma restantă, calculate până la data achitării integrale. Penalitățile se cumulează și pot fi reținute din garanție sau solicitate separat. Neachitarea penalităților nu exonerează chiriașul de obligația de plată a chiriei și utilităților.
    </td>
    <td class="col-en">
      The monthly rent amounts to <strong>${d.rentEur} EUR/month</strong>, being fixed over the entire period of agreement.<br>
      <strong>${d.ownerIban}</strong>, BIC/SWIFT: <strong>${d.ownerSwift}</strong><br>
      BANK: <strong>${d.ownerBank}</strong><br><br>
      
      On the date of signing the contract, the tenant pays the amount of <strong>${d.depositEur} Euro</strong>, which represents the apartment guarantee. <em>The deposit cannot be used as rent.</em><br><br>
      
      Until <strong>${d.firstPaymentDate}</strong>, the tenant will pay the amount of <strong>${d.firstPaymentAmount} EUR</strong> representing the rent for the first period.<br><br>
      
      The next payments will be made until <strong>${d.monthlyPaymentDay}</strong> of each month. The tenant is not exempt from paying the rent on summer or holiday.<br><br>
      
      The tenants will receive the keys and the right to enter in the apartment starting with <strong>${d.keysDate}</strong>.<br><br>
      
      <strong>Late payment penalties:</strong><br>
      For each day of delay in the payment of rent or utilities, the Tenant shall owe penalties of 0.1% of the outstanding amount, calculated until full payment is made. Penalties shall accrue and may be deducted from the deposit or claimed separately. Non-payment of penalties does not exempt the Tenant from the obligation to pay rent and utilities.
    </td>
  </tr>
</table>

<!-- ART. 5 -->
<div class="article-title">ART. 5 DREPTURI ȘI OBLIGAȚII / RIGHTS AND OBLIGATIONS</div>
<table class="bilingual-table">
  <tr>
    <td class="col-ro">
      <strong>a) Drepturile proprietarului:</strong>
      <ul>
        <li>să ceară rezilierea contractului, în cazul în care chiriașul nu-și respectă obligațiile prevăzute în prezentul contract.</li>
      </ul>
      
      <strong>b) Obligațiile proprietarului:</strong>
      <ul>
        <li>să predea chiriașilor bunul închiriat, precum și toate accesoriile acestuia, mobilat și în stare nouă;</li>
        <li>să pună la dispoziția chiriașilor spațiile închiriate în stare normală de folosință;</li>
        <li>să ia măsuri pentru repararea și menținerea în stare de siguranță în exploatare și de funcționalitate a clădirii pe toată durata închirierii locuinței;</li>
        <li>să întrețină în bune condiții instalațiile proprii clădirii (instalații de alimentare cu apă, de canalizare, instalații de încălzire centrală și de preparare a apei calde, instalații electrice și de gaze, centrala termică, instalații telefonice etc.);</li>
        <li>să suporte plata tuturor taxelor, impozitelor și a altor cheltuieli către bugetul de stat sau bugetul local care, potrivit legii, cad în sarcina proprietarului;</li>
        <li>să acorde chiriașilor un preaviz de 24 ore în situația în care intenționează să inspecteze spațiile închiriate, stabilind în prealabil o oră, de comun acord cu chiriașii;</li>
        <li>să returneze garanția la finalul contractului, dacă toate facturile sunt plătite la zi și nu s-au înregistrat stricăciuni în apartament, în maxim 15 zile.</li>
      </ul>
      
      <strong>c) Drepturile chiriașilor:</strong>
      <ul>
        <li>să i se asigure de către proprietar folosința bunului și a accesoriilor acestuia pe toată durata contractului.</li>
      </ul>
      
      <strong>d) Obligațiile chiriașilor:</strong>
      <ul>
        <li>să plătească chiria în condițiile prevăzute de prezentul contract și să achite toate utilitățile la timp;</li>
        <li>să folosească spațiile închiriate ca un bun proprietar, cu grijă și responsabilitate;</li>
        <li>să execute, pe cheltuiala sa, lucrările de întreținere și reparații curente interioare rezultate din utilizarea normală a bunului;</li>
        <li>să nu subînchirieze locuința fără acordul scris al proprietarului;</li>
        <li>să efectueze, pe cheltuiala sa, lucrările de reparații capitale doar dacă acestea sunt cauzate de culpa sa;</li>
        <li>să înștiințeze imediat proprietarul despre orice acțiune a unei terțe persoane care îi tulbură folosința;</li>
        <li>să mențină curățenia și igiena în interiorul locuinței și în spațiile comune pe toată durata contractului;</li>
        <li>să nu tulbure liniștea vecinilor prin comportamentul său;</li>
        <li>să răspundă pentru orice distrugere totală sau parțială a bunului închiriat cauzată din vina sa;</li>
        <li>să nu execute lucrări de investiții în spațiul închiriat fără acordul proprietarului;</li>
        <li>să suporte toate cheltuielile de utilizare (energie electrică, apă, canalizare, gaze) începând cu data preluării locuinței;</li>
        <li>să înlocuiască, pe cheltuiala sa, consumabilele precum becuri, furtun de duș, filtre etc., atunci când acestea se deteriorează;</li>
        <li>să restituie locuința la finalul contractului în aceeași stare în care a fost preluată: curată, igienizată și cu toate becurile funcționale;</li>
        <li>în cazul întârzierii plății chiriei cu mai mult de 2 zile lucrătoare, contractul se consideră reziliat automat, iar chiriașul pierde garanția și poate fi restricționat din imobil până la plata integrală a chiriei restante;</li>
        <li>să utilizeze corect aparatura din locuință (mașină de spălat, frigider etc.) conform manualului de utilizare;</li>
        <li>să nu introducă în mașina de spălat haine cu papuci plini de pământ sau pietre;</li>
        <li>să anunțe proprietarul dacă se mută o a doua persoană în locuință, comunicând numele și un document de identitate valid;</li>
        <li>să aerisească baia în timpul dușului și imediat după;</li>
        <li>să aerisească întreaga locuință la fiecare 1-2 zile, lăsând geamul ușor deschis timp de cel puțin 20 de minute, pentru a preveni apariția mucegaiului;</li>
        <li>să nu usuce haine în baie sau în cameră fără aerisire corespunzătoare; uscarea în spații închise fără ventilație favorizează apariția mucegaiului;</li>
        <li>mucegaiul rezultat din lipsa aerisirii sau din utilizarea necorespunzătoare a locuinței nu este responsabilitatea proprietarului; în astfel de cazuri, costurile remedierii vor fi reținute din garanție.</li>
      </ul>
      
      Dacă cheia este lăsată nesupravegheată, iar aceasta este pierdută sau preluată de o terță persoană, chiriașul va suporta integral costurile aferente schimbării yalei, montajului și timpul pierdut cauzat de această neglijență.
    </td>
    <td class="col-en">
      <strong>a) Owner's rights:</strong>
      <ul>
        <li>to request termination of the contract if the Tenant fails to fulfill the obligations stated in this agreement.</li>
      </ul>
      
      <strong>b) Owner's obligations:</strong>
      <ul>
        <li>to hand over the rented property and all its accessories to the Tenant, fully furnished and in new condition;</li>
        <li>to provide the rented premises in a usable and functional state;</li>
        <li>to take necessary measures to repair and maintain the building in safe and operational condition throughout the rental period;</li>
        <li>to maintain in good condition the building's systems (water supply, sewage, central heating, hot water, electrical and gas installations, heating unit, telephone lines, etc.);</li>
        <li>to cover all taxes, duties, and other charges owed to the state or local budget that, by law, fall under the Owner's responsibility;</li>
        <li>to give the Tenant at least 24 hours' notice before inspecting the rented premises, and to agree in advance on a time with the Tenant;</li>
        <li>to return the security deposit at the end of the contract, within a maximum of 15 days, provided that all bills are paid in full and no damage has been recorded in the apartment.</li>
      </ul>
      
      <strong>c) Tenant's rights:</strong>
      <ul>
        <li>to have uninterrupted use of the property and its accessories for the entire duration of the contract, as guaranteed by the Owner.</li>
      </ul>
      
      <strong>d) Tenant's obligations:</strong>
      <ul>
        <li>to pay the rent in accordance with the terms of this contract and to pay all utility bills on time;</li>
        <li>to use the rented premises responsibly, as a good tenant;</li>
        <li>to carry out, at their own expense, all routine maintenance and minor repairs resulting from normal use of the property;</li>
        <li>not to sublet the apartment without the written consent of the Owner;</li>
        <li>to carry out, at their own expense, any major repairs only if they are caused by the Tenant's fault;</li>
        <li>to immediately notify the Owner of any third-party action that interferes with the peaceful use of the property;</li>
        <li>to maintain cleanliness and hygiene inside the apartment and in shared common areas throughout the rental period;</li>
        <li>not to disturb the peace of neighboring properties through their behavior;</li>
        <li>to be liable for any total or partial damage to the rented property caused by their fault;</li>
        <li>not to make any structural or investment changes to the property without the Owner's approval;</li>
        <li>to bear all usage-related costs (electricity, water, sewage, gas) starting from the date of taking possession of the apartment;</li>
        <li>to replace, at their own expense, consumables such as light bulbs, shower hoses, filters, etc., when they wear out;</li>
        <li>to return the apartment at the end of the contract in the same condition in which it was received: clean, hygienic, and with all light bulbs functional;</li>
        <li>in case of rent payment delay exceeding 2 working days, the contract shall be considered automatically terminated, the Tenant forfeits the deposit, and may be restricted from the property until full payment is made;</li>
        <li>to use all appliances (washing machine, refrigerator, etc.) properly and according to the user manuals;</li>
        <li>not to place shoes full of mud or stones in the washing machine;</li>
        <li>to inform the Owner if a second person moves into the apartment, providing their name and a valid identity document;</li>
        <li>to ventilate the bathroom during and immediately after showering;</li>
        <li>to ventilate the entire apartment every 1–2 days by leaving a window slightly open for at least 20 minutes, in order to prevent mold;</li>
        <li>to avoid drying clothes in the bathroom or bedroom without proper ventilation; drying in closed spaces without airflow encourages mold growth;</li>
        <li>mold caused by lack of ventilation or improper use of the apartment is not the Owner's responsibility; in such cases, the cost of remediation will be deducted from the deposit.</li>
      </ul>
      
      If the key is left unattended and is lost or taken by a third party, the Tenant will bear the full cost of replacing the lock, installation, and the inconvenience caused by this negligence.
    </td>
  </tr>
</table>

<!-- ART. 6 -->
<div class="article-title">ART. 6 ÎNCETAREA CONTRACTULUI / TERMINATION OF THE CONTRACT</div>
<table class="bilingual-table">
  <tr>
    <td class="col-ro">
      Prezentul contract își încetează efectele în următoarele cazuri:
      <ul>
        <li>La expirarea perioadei prevăzute în contract, dacă nu se prelungește prin acordul ambelor părți;</li>
        <li>Prin rezilierea anticipată de către oricare dintre părți, cu un preaviz de minimum 90 de zile;</li>
        <li>Prin neplata cheltuielilor de utilizare (energie electrică, apă, canalizare, gaze etc.) timp de o lună, caz în care contractul se reziliază unilateral de către proprietar;</li>
        <li>În cazul întârzierii plății chiriei cu mai mult de 5 zile lucrătoare de la data scadentă, proprietarul are dreptul să transmită o notificare scrisă prin email către chiriaș. Dacă plata nu este efectuată în termen de maximum 5 zile lucrătoare de la notificare, contractul se consideră reziliat de drept, iar chiriașul pierde garanția și poate fi restricționat din imobil până la plata integrală a chiriei restante. Durata transferului bancar nu este responsabilitatea proprietarului.</li>
      </ul>
      
      Plata chiriei trebuie efectuată la data scadentă stabilită în contract. Este responsabilitatea chiriașului să respecte termenele de plată. Întârzierile repetate sau justificările nefondate pot fi considerate tentativă de prelungire ilegală a șederii fără plată, caz în care contractul se reziliază, iar chiriașul pierde garanția și este obligat să părăsească apartamentul imediat.<br><br>
      
      În cazul rezilierii anticipate de către chiriaș, fără respectarea perioadei contractuale și fără acordul proprietarului, chiriașul datorează o compensație echivalentă cu chiria aferentă perioadei rămase până la expirarea contractului, dar nu mai mult de 2 luni de chirie. Această compensație are rolul de a acoperi prejudiciul cauzat de încetarea anticipată și se poate reține integral sau parțial din garanție, iar dacă garanția nu acoperă suma, chiriașul va achita diferența.<br><br>
      
      Garanția nu poate fi folosită pentru plata chiriei, a utilităților restante sau a curățeniei. Ea poate fi reținută doar pentru daune materiale sau încălcări ale obligațiilor contractuale.<br><br>
      
      <strong>Curățenie la predare:</strong><br>
      La încetarea contractului, chiriașul este obligat să predea apartamentul în aceeași stare de curățenie în care l-a primit. Dacă locuința nu este curată conform standardelor inițiale, se va efectua o curățenie profesională realizată de o firmă autorizată. Costul acestei curățenii va fi stabilit conform facturii emise de furnizorul de servicii, în funcție de suprafața și starea apartamentului, orientativ între 700-1200 RON (sau echivalentul în EUR).<br><br>
      
      Această curățenie finală include:
      <ul>
        <li>degresarea și curățarea aragazului, cuptorului, plitei, hotei și frigiderului</li>
        <li>igienizarea băii: duș, toaletă, chiuvetă</li>
        <li>spălarea geamurilor și a perdelelor</li>
        <li>aspirarea și spălarea podelelor</li>
        <li>ștergerea tuturor suprafețelor</li>
      </ul>
      
      Chiriașul are opțiunea să aleagă o firmă de curățenie proprie, cu condiția ca aceasta să efectueze toate operațiunile menționate și să prezinte o chitanță fiscală. În caz de refuz sau neexecutare, proprietarul își rezervă dreptul de a acționa în instanță pentru recuperarea costurilor. Curățenia trebuie să fie completă, nu superficială. Apartamentul trebuie predat exact în starea în care a fost primit. Firma de curățenie va face fotografii la intrarea în apartament și după curățenie, pentru a documenta starea locuinței. Această intervenție are loc doar la plecarea chiriașului, nu este o curățenie săptămânală sau de întreținere.<br><br>
      
      <strong>Predarea cheii la finalul contractului:</strong><br>
      La încetarea contractului, chiriașul este obligat să predea cheia apartamentului personal proprietarului sau unei persoane desemnate de acesta. Nu este permisă lăsarea cheii în cutia poștală, în ușă sau în alte locuri nesecurizate. Dacă cheia este lăsată nesupravegheată, iar aceasta este pierdută sau preluată de o terță persoană, chiriașul va suporta integral costurile aferente schimbării yalei, montajului și timpul pierdut cauzat de această neglijență.<br><br>
      
      Standardul de curățenie este cel documentat prin fotografiile realizate la semnarea contractului. La încetarea contractului, apartamentul trebuie predat în aceeași stare.
    </td>
    <td class="col-en">
      This contract shall terminate in the following cases:
      <ul>
        <li>Upon expiration of the contractual period, unless extended by mutual agreement;</li>
        <li>By early termination by either party, with a minimum notice of 90 days;</li>
        <li>In case of non-payment of utility bills (electricity, water, sewage, gas, etc.) for one month, the contract shall be unilaterally terminated by the Landlord;</li>
        <li>In case of rent payment delay exceeding 5 working days from the due date, the Landlord has the right to send a written notice by email to the Tenant. If payment is not made within a maximum of 5 working days from the notice, the contract shall be legally terminated, the Tenant forfeits the deposit, and may be restricted from the property until full payment is made. The duration of the bank transfer is not the Landlord's responsibility.</li>
      </ul>
      
      Rent must be paid on the contractual due date. It is the Tenant's responsibility to respect payment deadlines. Repeated delays or unfounded excuses may be considered an attempt to unlawfully extend the stay without payment, in which case the contract shall be terminated, the Tenant forfeits the deposit, and must vacate the apartment immediately.<br><br>
      
      In the event of early termination by the Tenant, without respecting the contractual period and without the Landlord's consent, the Tenant shall owe compensation equivalent to the rent for the remaining period until the contract's expiry, but not exceeding 2 months' rent. This compensation is intended to cover damages caused by early termination and may be withheld in full or in part from the deposit. If the deposit does not cover the amount, the Tenant shall pay the difference.<br><br>
      
      The deposit cannot be used to pay rent, outstanding utility bills, or cleaning fees. It may only be withheld in case of material damage or breach of contractual obligations.<br><br>
      
      <strong>Cleaning at handover:</strong><br>
      Upon termination of the contract, the Tenant is required to return the apartment in the same clean condition in which it was received. If the apartment is not cleaned to the initial standards, professional cleaning will be carried out by an authorized company. The cost of this cleaning shall be determined according to the invoice issued by the service provider, depending on the apartment's size and condition, typically ranging between 700-1200 RON (or equivalent in EUR).<br><br>
      
      This final cleaning includes:
      <ul>
        <li>degreasing and cleaning the stove, oven, hob, hood, and refrigerator</li>
        <li>sanitizing the bathroom: shower, toilet, sink</li>
        <li>washing windows and curtains</li>
        <li>vacuuming and mopping floors</li>
        <li>wiping all surfaces</li>
      </ul>
      
      The Tenant may choose their own cleaning company, provided all the above tasks are completed and a fiscal receipt is presented. In case of refusal or failure to comply, the Landlord reserves the right to take legal action to recover the costs. The cleaning must be thorough, not superficial. The apartment must be returned in the exact condition in which it was received. The cleaning company will take photos upon entering and after cleaning the apartment to document its condition. This service is performed only at the end of the rental period and is not a weekly or maintenance cleaning.<br><br>
      
      <strong>Key return at the end of the contract:</strong><br>
      At the end of the contract, the Tenant must return the apartment key directly to the Landlord or to a person designated by the Landlord. Leaving the key in the mailbox, in the door, or in any unsecured location is strictly prohibited. If the key is left unattended and is lost or taken by a third party, the Tenant will bear the full cost of replacing the lock, installation, and the inconvenience caused by this negligence.<br><br>
      
      The cleanliness standard is documented by the photographs taken at the signing of the contract. At the end of the contract, the apartment must be returned in the same condition.
    </td>
  </tr>
</table>

<!-- ART. 7 -->
<div class="article-title">ART. 7 COMUNICAREA ȘI REPREZENTAREA / COMMUNICATION AND REPRESENTATION</div>
<table class="bilingual-table">
  <tr>
    <td class="col-ro">
      Toate discuțiile, negocierile și comunicările referitoare la prezentul contract se vor purta exclusiv între proprietar și chiriaș. Nicio altă persoană (inclusiv membri ai familiei precum tatăl, mama, sora, veri etc.) nu are calitatea legală de a interveni, negocia sau reprezenta părțile în legătură cu acest contract.<br><br>
      
      Doar persoanele menționate în mod expres în contract și care sunt prezente la semnarea acestuia pot fi implicate în comunicări sau decizii legate de contract. În lipsa acestor condiții, orice altă persoană este considerată terț fără drept de reprezentare.<br><br>
      
      În cazul în care chiriașul are nevoie de sprijin lingvistic sau interpretare, poate apela la un interpret autorizat. Cu toate acestea, proprietarul vorbește limba engleză și este disponibil pentru comunicare directă în această limbă.
    </td>
    <td class="col-en">
      All discussions, negotiations, and communications related to this contract shall take place exclusively between the Owner and the Tenant. No other person (including family members such as father, mother, sister, cousin, etc.) has the legal capacity to intervene, negotiate, or represent either party in relation to this contract.<br><br>
      
      Only persons explicitly mentioned in the contract and present at the time of signing may be involved in communications or decisions related to the agreement. In the absence of these conditions, any other person is considered a third party without the right of representation.<br><br>
      
      If the Tenant requires language assistance or interpretation, they may use a certified interpreter. However, the Owner speaks English and is available for direct communication in this language.
    </td>
  </tr>
</table>

<!-- ART. 8 -->
<div class="article-title">ART. 8 GARANȚIA (DEPOZITUL DE GARANȚIE) / SECURITY DEPOSIT</div>
<table class="bilingual-table">
  <tr>
    <td class="col-ro">
      Garanția achitată de chiriaș la semnarea contractului are rol exclusiv de acoperire a eventualelor prejudicii cauzate de nerespectarea obligațiilor contractuale. Aceasta nu poate fi utilizată pentru plata chiriei curente, a facturilor de utilități, a serviciilor de curățenie sau a altor cheltuieli obișnuite.<br><br>
      
      Garanția nu este o sumă disponibilă pentru consum în timpul derulării contractului. Ea este reținută de proprietar pe toată durata contractului și poate fi restituită doar la finalul acestuia, în termen de maximum 30 de zile, după achitarea integrală a chiriei și utilităților și după primirea tuturor facturilor finale de la furnizorii de utilități și asociația de proprietari.<br><br>
      
      <strong>Restituirea garanției se va face numai dacă:</strong>
      <ul>
        <li>toate obligațiile contractuale au fost respectate;</li>
        <li>chiria și utilitățile au fost achitate integral;</li>
        <li>apartamentul este predat în aceeași stare de curățenie și funcționalitate în care a fost primit;</li>
        <li>nu există daune sau intervenții neautorizate asupra proprietății.</li>
      </ul>
      
      Proprietarul are dreptul să rețină integral sau parțial garanția pentru acoperirea prejudiciilor cauzate de chiriaș:
      <ul>
        <li>Pentru obligații financiare certe (chirie restantă, utilități neachitate, reziliere anticipată), garanția poate fi reținută fără justificări suplimentare, pe baza contractului și a facturilor.</li>
        <li>Pentru daune materiale sau intervenții neautorizate, proprietarul va transmite chiriașului un sumar justificativ (proces-verbal de constatare, fotografii, facturi sau chitanțe), în termen de 30 de zile de la încetarea contractului.</li>
        <li>În cazul rezilierii contractului conform Art. 6, garanția poate fi reținută integral sau parțial pentru acoperirea obligațiilor restante.</li>
      </ul>
    </td>
    <td class="col-en">
      The deposit paid by the Tenant upon signing the contract serves exclusively as coverage for any damages resulting from the breach of contractual obligations. It cannot be used to pay current rent, utility bills, cleaning services, or other regular expenses.<br><br>
      
      The deposit is not an amount available for consumption during the term of the contract. It is held by the Landlord for the entire duration of the agreement and may only be refunded at the end of the contract, within a maximum of 30 days, after full payment of rent and utilities and upon receipt of all final invoices from utility providers and the owners' association.<br><br>
      
      <strong>The deposit shall only be refunded if:</strong>
      <ul>
        <li>all contractual obligations have been fulfilled;</li>
        <li>rent and utilities have been paid in full;</li>
        <li>the apartment is returned in the same clean and functional condition as it was received;</li>
        <li>no damages or unauthorized interventions to the property exist.</li>
      </ul>
      
      The Landlord has the right to retain the deposit in full or in part to cover damages caused by the Tenant:
      <ul>
        <li>For clear financial obligations (unpaid rent, outstanding utilities, early termination), the deposit may be withheld without further justification, based on the contract and invoices.</li>
        <li>For material damages or unauthorized interventions, the Landlord shall provide the Tenant with a summary justification (inspection report, photos, invoices or receipts) within 30 days from termination of the contract.</li>
        <li>In case of termination of the contract under Art. 6, the deposit may be withheld in full or in part to cover outstanding obligations.</li>
      </ul>
    </td>
  </tr>
</table>

<!-- ART. 9 -->
<div class="article-title">ART. 9 COMUNICARE ȘI RAPORTARE LUNARĂ A UTILITĂȚILOR / COMMUNICATION AND MONTHLY UTILITY REPORTING</div>
<table class="bilingual-table">
  <tr>
    <td class="col-ro">
      Chiriașul este obligat să furnizeze o adresă de email validă și activă la momentul semnării contractului.<br><br>
      
      Comunicările oficiale dintre proprietar și chiriaș se vor face în principal prin email, la adresele declarate în contract.<br><br>
      
      Fiecare parte are obligația să confirme primirea mesajului printr-un răspuns scurt („Confirm primirea").<br><br>
      
      Dacă nu există confirmare în termen de 48 de ore, expeditorul va retransmite mesajul și, la nevoie, îl va duplica prin SMS/WhatsApp sau scrisoare recomandată, în scop probator.<br><br>
      
      Proprietarul nu este responsabil pentru mesajele pierdute din cauza neglijenței chiriașului în verificarea emailului, cu condiția ca mesajul să fi fost transmis corect la adresa declarată.<br><br>
      
      <strong>Lunar, chiriașul va transmite prin email la adresa office@rentiasi.ro</strong>, cu subiectul care conține adresa completă a apartamentului închiriat, următoarele fotografii:
      <ol>
        <li>O fotografie clară cu contorul de apă din baie</li>
        <li>O fotografie clară cu contorul de gaz</li>
        <li>O fotografie clară cu contorul de energie electrică</li>
      </ol>
      
      Pentru contorul electric, chiriașul va transmite fotografia cadranului principal de consum (de regulă codul 1.8.0 sau echivalent), conform instrucțiunilor furnizorului de energie. Dacă afișajul este digital și se schimbă automat, chiriașul poate realiza un scurt videoclip și extrage fotografia cadranului relevant.<br><br>
      
      Aceste citiri sunt necesare pentru emiterea corectă a facturilor de utilități. În lipsa transmiterii datelor, furnizorii pot emite facturi pe baza estimărilor proprii, iar eventualele diferențe față de consumul real vor fi suportate de chiriaș.
    </td>
    <td class="col-en">
      The Tenant must provide a valid and active email address at the time of signing the contract.<br><br>
      
      Official communications between the Landlord and the Tenant shall be conducted primarily via email, using the addresses stated in the contract.<br><br>
      
      Each party must confirm receipt of the message with a short reply ("Receipt confirmed").<br><br>
      
      If no confirmation is received within 48 hours, the sender shall resend the message and, if necessary, duplicate it via SMS/WhatsApp or registered mail for evidentiary purposes.<br><br>
      
      The Landlord shall not be held responsible for missed messages due to the Tenant's failure to check their email, provided the message was correctly sent to the declared address.<br><br>
      
      <strong>Monthly, the Tenant shall send an email to office@rentiasi.ro</strong>, with the subject containing the full address of the rented apartment, including the following photos:
      <ol>
        <li>A clear photo of the water meter in the bathroom</li>
        <li>A clear photo of the gas meter</li>
        <li>A clear photo of the electricity meter</li>
      </ol>
      
      For the electricity meter, the Tenant shall send a photo of the main consumption display (usually code 1.8.0 or equivalent), as required by the energy provider. If the display is digital and changes automatically, the Tenant may record a short video and extract the relevant frame.<br><br>
      
      These readings are necessary for accurate utility billing. If the Tenant fails to provide them, the providers may issue bills based on their own estimates, and any differences from the actual consumption shall be borne by the Tenant.
    </td>
  </tr>
</table>

<!-- ART. 10 -->
<div class="article-title">ART. 10 COMUNICĂRI ȘI NOTIFICĂRI / COMMUNICATION AND NOTICES</div>
<table class="bilingual-table">
  <tr>
    <td class="col-ro">
      Toate notificările, solicitările sau discuțiile oficiale între părți se vor face în principal prin email, la adresele comunicate în contract.
      <ul>
        <li>Fiecare parte are obligația să confirme primirea mesajului printr-un răspuns scurt (ex.: „Confirm primirea").</li>
        <li>Dacă nu există confirmare în termen de 48 de ore, expeditorul va retransmite mesajul și, la nevoie, îl va duplica prin SMS/WhatsApp sau scrisoare recomandată, în scop probator.</li>
        <li>Comunicările prin telefon, SMS sau WhatsApp au valoare de informare, dar nu înlocuiesc notificările oficiale transmise prin email sau scrisoare recomandată.</li>
        <li>Data comunicării este considerată data livrării mesajului în inbox sau data ștampilei poștale, după caz.</li>
      </ul>
    </td>
    <td class="col-en">
      All official notifications, requests, or discussions between the parties shall be conducted primarily via email, using the addresses stated in the contract.
      <ul>
        <li>Each party must confirm receipt of the message with a short reply (e.g., "Receipt confirmed").</li>
        <li>If no confirmation is received within 48 hours, the sender shall resend the message and, if necessary, duplicate it via SMS/WhatsApp or registered mail for evidentiary purposes.</li>
        <li>Communications via phone, SMS, or WhatsApp are informative only and do not replace official notifications sent by email or registered mail.</li>
        <li>The communication date shall be considered the inbox delivery timestamp or the postal stamp date, as applicable.</li>
      </ul>
    </td>
  </tr>
</table>

<!-- ART. 11 -->
<div class="article-title">ART. 11 MODALITĂȚI DE PLATĂ / PAYMENT METHODS</div>
<table class="bilingual-table">
  <tr>
    <td class="col-ro">
      Chiria poate fi achitată prin una dintre următoarele metode:<br><br>
      
      <strong>1. Transfer bancar</strong> în contul proprietarului, folosind următoarele date:<br>
      • Nume beneficiar: <strong>${d.ownerName}</strong><br>
      • Banca: <strong>${d.ownerBank}</strong><br>
      • Țara: <strong>${d.ownerBankCountry}</strong><br>
      • IBAN: <strong>${d.ownerIban}</strong><br>
      • SWIFT/BIC: <strong>${d.ownerSwift}</strong><br><br>
      
      <strong>2. Plată în numerar</strong>, doar cu acordul prealabil al proprietarului.<br><br>
      
      Chiriașul este responsabil să efectueze plata integrală până la data scadentă, indiferent de metoda aleasă. Comisioanele bancare (dacă există) sunt suportate de chiriaș. Plata se consideră efectuată doar în momentul în care suma este vizibilă în contul proprietarului sau este înmânată direct acestuia.<br><br>
      
      Întârzierile sau neplata atrag penalități conform Art. 4 și pot conduce la rezilierea contractului conform Art. 6.
    </td>
    <td class="col-en">
      The rent may be paid using one of the following methods:<br><br>
      
      <strong>1. Bank transfer</strong> to the Owner's account, using the following details:<br>
      • Beneficiary name: <strong>${d.ownerName}</strong><br>
      • Bank: <strong>${d.ownerBank}</strong><br>
      • Country: <strong>${d.ownerBankCountry}</strong><br>
      • IBAN: <strong>${d.ownerIban}</strong><br>
      • SWIFT/BIC: <strong>${d.ownerSwift}</strong><br><br>
      
      <strong>2. Cash payment</strong>, only with the prior consent of the Owner.<br><br>
      
      The Tenant is responsible for making full payment by the due date, regardless of the chosen method. Any bank fees (if applicable) are borne by the Tenant. The payment is considered completed only when the amount is visible in the Owner's account or handed directly to the Owner.<br><br>
      
      Delays or non-payment shall incur penalties under Art. 4 and may lead to termination of the contract under Art. 6.
    </td>
  </tr>
</table>

<!-- ART. 12 -->
<div class="article-title">ART. 12 REPARAȚII MAJORE ȘI MINORE / MAJOR AND MINOR REPAIRS (Art. 1788 Cod Civil)</div>
<table class="bilingual-table">
  <tr>
    <td class="col-ro">
      În conformitate cu art. 1788 din Codul civil, locatorul (proprietarul/landlord) este obligat să efectueze toate reparațiile majore necesare pentru menținerea imobilului în stare corespunzătoare de folosință, iar locatarul (chiriașul/tenant) este responsabil pentru reparațiile locative, rezultate din uzura normală a bunului, precum înlocuirea becurilor arse, schimbarea furtunelor de duș deteriorate, curățarea și deblocarea țevilor înfundate cu păr sau reziduuri, evitarea aruncării obiectelor textile sau altor materiale în vasul de WC ori scurgeri, repararea sau înlocuirea robineților folosiți în mod anormal sau defectuos, precum și repararea scaunelor rupte, a meselor crăpate ori deteriorate prin utilizare necorespunzătoare și întreținerea plaselor de țânțari, inclusiv evitarea lăsării deschise și deteriorării acestora de către vânt.<br><br>
      
      Proprietarul va evalua situația și, dacă consideră necesar, poate înlocui bunul defect, însă în cazul deteriorărilor multiple cauzate de utilizarea necorespunzătoare, acestea nu vor fi în sarcina sa.
    </td>
    <td class="col-en">
      In accordance with Article 1788 of the Romanian Civil Code, the landlord (locator/proprietar) is obliged to carry out all major repairs necessary to maintain the property in proper condition for use, while the tenant (locatar/chiriaș) is responsible for minor repairs resulting from the normal wear and tear of the property, such as replacing burnt-out light bulbs, changing damaged shower hoses, cleaning and unclogging pipes blocked by hair or residues, avoiding the disposal of textiles or other materials into the toilet or drains, repairing or replacing taps subjected to abnormal or improper use, repairing broken chairs or cracked tables caused by improper use, and maintaining mosquito nets, including avoiding leaving them open and allowing them to be damaged by wind.<br><br>
      
      The landlord will assess the situation and, if deemed necessary, may replace the defective item; however, in the case of multiple damages caused by improper use, these shall not be the landlord's responsibility.
    </td>
  </tr>
</table>

<!-- ART. 13 -->
<div class="article-title">ART. 13 ACCEPTAREA BUNURILOR LA SEMNARE / ACCEPTANCE OF GOODS AT SIGNING</div>
<table class="bilingual-table">
  <tr>
    <td class="col-ro">
      La momentul semnării contractului, locatarul (chiriașul/tenant) declară că a acceptat bunurile și dotările existente puse la dispoziție în imobil, precum salteaua, televizorul, mobilierul și alte obiecte. Ulterior, nu se pot solicita schimbări sau înlocuiri decât în cazul în care un bun nu mai poate fi utilizat sau s-a defectat.<br><br>
      
      Odată ce bunurile au fost acceptate la semnare, nu se pot formula pretenții suplimentare privind înlocuirea, modernizarea sau modificarea acestora, cu excepția situațiilor în care locatorul (proprietarul/landlord) consideră necesar să le înlocuiască sau să le repare din cauza unor defecte reale. În mod expres se precizează că la înlocuirea saltelei de pat nu pot apărea pretenții subiective legate de confort, cum ar fi dureri de spate sau dorința de a primi o saltea ultra premium.
    </td>
    <td class="col-en">
      At the time of signing the contract, the tenant (locatar/chiriaș) declares that he/she has accepted the existing goods and equipment provided with the property, such as the mattress, television, furniture, and other items. Afterwards, no changes or replacements may be requested unless an item can no longer be used or has become defective.<br><br>
      
      Once the goods have been accepted upon signing, no further claims regarding their replacement, upgrading, or modification shall be made, except in cases where the landlord (locator/proprietar) considers it necessary to replace or repair them due to legitimate defects. It is expressly stated that, in the case of mattress replacement, no subjective claims related to personal comfort, such as back pain or the desire for an ultra-premium mattress, shall be accepted.
    </td>
  </tr>
</table>

<!-- NOTA FINALA -->
<div style="margin-top: 15px; padding: 10px; background: #f5f5f5; border: 1px solid #ddd; font-size: 9pt;">
  <strong>Notă finală / Final Note:</strong><br><br>
  <strong>RO:</strong> Prezentul contract este redactat pe baza unei experiențe de peste 15 ani în administrarea imobilelor, având în vedere situațiile frecvent întâlnite în practică, precum cazurile în care chiriașii părăsesc locuința fără respectarea obligațiilor contractuale sau lasă cheile și pleacă fără notificare. Astfel de comportamente nu exonerează chiriașul de răspunderea legală și contractuală, iar proprietarul își rezervă dreptul de a aplica toate măsurile prevăzute de lege și de prezentul contract.<br><br>
  
  <strong>EN:</strong> This contract has been drafted based on more than 15 years of experience in property management, taking into account situations frequently encountered in practice, such as tenants leaving the premises without fulfilling their contractual obligations or abandoning the keys without notice. Such behavior does not exempt the tenant from legal and contractual liability, and the landlord reserves the right to enforce all measures provided by law and by this agreement.
</div>

<!-- SEMNARE -->
<div class="signature-section">
  <p style="text-align: center; font-weight: bold; margin-bottom: 15px;">
    Acest contract a fost semnat astăzi / This contract was signed today: <u>&nbsp;&nbsp;${d.contractDate}&nbsp;&nbsp;</u>
  </p>
  
  <div class="signature-row">
    <div class="signature-block">
      <h4>PROPRIETAR / OWNER</h4>
      <p>Nume și Semnătură:</p>
      <p><strong>${d.ownerName}</strong></p>
      <div class="signature-line"></div>
    </div>
    <div class="signature-block">
      <h4>CHIRIAȘ / TENANT</h4>
      <p>Print Name:</p>
      <p><strong>${d.tenantName}</strong></p>
      <div class="signature-line"></div>
      <p style="margin-top: 8px;">Signature:</p>
      <div class="signature-line"></div>
    </div>
  </div>
</div>

<!-- LEGAL SECTION -->
<div class="legal-section">
  <h4>Respectarea obligațiilor contractuale, impactul legal, competența teritorială și protecția datelor cu caracter personal / Compliance with Contractual Obligations, Legal Impact, Jurisdiction, and Data Protection</h4>
  
  <p><strong>RO:</strong> Contractul de închiriere este guvernat de Codul Civil al României (Art. 1777-1835) privind contractele de locațiune și de Legea 114/1996, Art. 28-29. Se aplică în mod expres și dispozițiile art. 1788 Cod civil, conform cărora locatorul (proprietarul/landlord) este obligat să efectueze reparațiile majore, iar locatarul (chiriașul/tenant) este responsabil pentru reparațiile locative, rezultate din uzura normală a bunului. Semnarea acestui document implică acceptarea tuturor obligațiilor stipulate, iar nerespectarea acestora poate atrage consecințe juridice directe, inclusiv rezilierea contractului și acțiuni în instanță.</p>
  
  <p>Faptele de furt sau deteriorarea proprietății sunt reglementate de Codul Penal, Art. 228, iar neplata obligațiilor financiare (chirie, utilități, taxe) sau lăsarea apartamentului într-o stare necorespunzătoare pot fi raportate autorităților competente. Acest lucru poate influența viza, permisul de ședere sau alte drepturi administrative ale chiriașului străin.</p>
  
  <p>Deoarece România este stat membru al Uniunii Europene, măsurile legale împotriva chiriașilor străini pot fi extinse și în țara de origine a acestora, prin mecanismele de cooperare juridică europeană. Autoritățile române pot solicita aplicarea sancțiunilor sau recuperarea datoriilor în alte state membre ale UE.</p>
  
  <p>Părțile convin că orice litigiu apărut în legătură cu prezentul contract, inclusiv referitor la validitatea, interpretarea, executarea sau încetarea acestuia, va fi soluționat de instanțele judecătorești competente din Municipiul Iași, România.</p>
  
  <p>Părțile declară că datele personale furnizate în prezentul contract vor fi utilizate exclusiv în scopul derulării contractului, conform Regulamentului (UE) 2016/679 privind protecția persoanelor fizice în ceea ce privește prelucrarea datelor cu caracter personal (GDPR).</p>
  
  <hr style="margin: 10px 0;">
  
  <p><strong>EN:</strong> The rental contract is governed by the Romanian Civil Code (Articles 1777-1835) regarding lease agreements and Law 114/1996, Articles 28-29. Article 1788 of the Civil Code also expressly applies, under which the landlord (locator/proprietar) is obliged to carry out major repairs, while the tenant (locatar/chiriaș) is responsible for minor repairs resulting from the normal wear and tear of the property. Signing this document implies acceptance of all stipulated obligations, and failure to comply may result in legal consequences, including termination of the contract and legal actions.</p>
  
  <p>Acts of theft or property damage are regulated by Article 228 of the Penal Code and may lead to serious legal consequences, including criminal liability. In severe cases, failure to fulfill financial obligations (rent, utilities, fees) or leaving the apartment in an unacceptable condition may be reported to the relevant authorities, potentially affecting the tenant's visa, residence permit, or other administrative rights.</p>
  
  <p>As Romania is a member state of the European Union, legal measures against foreign tenants may extend to their country of origin through European judicial cooperation mechanisms. Romanian authorities may request enforcement of penalties or debt recovery in other EU member states.</p>
  
  <p>The parties agree that any dispute arising in connection with this contract, including those related to its validity, interpretation, execution, or termination, shall be settled by the competent courts of Iași Municipality, Romania.</p>
  
  <p>The parties declare that personal data provided in this contract will be used exclusively for the purpose of contract execution, in accordance with Regulation (EU) 2016/679 on the protection of individuals regarding personal data processing (GDPR).</p>
</div>

<div class="page-footer">
  Contract generat de RENTIASI.RO
</div>

</body>
</html>`;
};
